export function assertNever(value: never): never {
  throw new Error(`Impossible! Unexpected value sent to assertNever: ${JSON.stringify(value)}`);
}
